import { render } from "./videoManagement.vue?vue&type=template&id=00ccc5e1&scoped=true"
import script from "./videoManagement.vue?vue&type=script&lang=js"
export * from "./videoManagement.vue?vue&type=script&lang=js"

import "./videoManagement.vue?vue&type=style&index=0&id=00ccc5e1&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ccc5e1"]])

export default __exports__